import type * as API from 'interfaces/api';
import type * as DB from 'interfaces/database';

export function findOfferingPageSpecification(
	pages: ReadonlyArray<API.OfferingDataPageSpecification>,
	offeringId: DB.OfferingModel['id'],
	pageIndex: number,
): API.OfferingDataPageSpecification | undefined {
	return pages.find((page) => (
		page.offeringId === offeringId
		&& page.pageIndex === pageIndex
	));
}

export function mergeOfferingPageSpecifications(
	currentPages: ReadonlyArray<API.OfferingDataPageSpecification>,
	incomingPages: ReadonlyArray<API.OfferingDataPageSpecification>,
): API.OfferingDataPageSpecification[] {
	return [
		...currentPages.filter((currentPage) => (
			!incomingPages.some((incomingPage) => (
				incomingPage.offeringId === currentPage.offeringId
				&& incomingPage.pageIndex === currentPage.pageIndex
			))
		)),
		...incomingPages,
	];
}

export function isOfferingPageBackgroundSupported(
	backgroundType: API.ProductSpecificationBackgroundType,
): boolean {
	return (
		backgroundType === 'any'
		|| backgroundType === 'color'
	);
}

export function isOfferingPageTransparentBackgroundSupported(
	backgroundType: API.ProductSpecificationBackgroundType,
): boolean {
	return backgroundType === 'any';
}
